import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {AddressServiceRequestExtended} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormLocationInfo from './InnerFormLocationInfo';
import {FieldShape} from 'commons/shapes';
import {formValidator, setDefaultValue} from 'commons/utils/Functions';

LocationInfoForm.propTypes = {
    address: PropTypes.any,
    submitHandler: PropTypes.func.isRequired,
    showAdditionalAddress: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof LocationInfoForm.propTypes>,
    AddressServiceRequestExtended
>({
    mapPropsToErrors: () => {
        return {
            expedientId: '',
            workflowId: '',
            viewId: '',
            viewFatherId: '',
            kycId: '',
            addressId: '',
            streetDescription: '',
            streetDescriptionNat: '',
            outdoorNumber: '',
            interiorNumber: '',
            zipCode: '',
            colonyKey: '',
            colonyDescription: '',
            colonyDescriptionNat: '',
            municipalityKey: '',
            municipalityDescription: '',
            stateKey: '',
            stateDescription: '',
            countryKey: '',
            addressDescription: '',
            hasNext: '',
            addressDescriptionNat: '',
            outdoorNumberNat: '',
            interiorNumberNat: '',
            zipCodeNat: '',
            colonyKeyNat: '',
            municipalityKeyNat: '',
            municipalityDescriptionNat: '',
            stateKeyNat: '',
            stateDescriptionNat: '',
            countryKeyNat: '',
        };
    },
    mapPropsToValues: (props) => {
        const {address} = props;
        if (address) {
            return {
                expedientId: address.expedientId,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                addressId: setDefaultValue(address.addressId, 1),
                streetDescription: setDefaultValue(address.streetDescription, ''),
                streetDescriptionNat: setDefaultValue(address.streetDescriptionNat, ''),
                outdoorNumber: setDefaultValue(address.outdoorNumber, ''),
                interiorNumber: setDefaultValue(address.interiorNumber, ''),
                zipCode: setDefaultValue(address.zipCode, ''),
                colonyKey: setDefaultValue(address.colonyKey, ''),
                colonyDescription: setDefaultValue(address.colonyDescription, ''),
                colonyDescriptionNat: setDefaultValue(address.colonyDescriptionNat, ''),
                municipalityKey: setDefaultValue(address.municipalityKey, ''),
                municipalityDescription: setDefaultValue(address.municipalityDescription, ''),
                stateKey: setDefaultValue(address.stateKey, ''),
                stateDescription: setDefaultValue(address.stateDescription, ''),
                countryKey: setDefaultValue(address.countryKey, ''),
                addressDescription: setDefaultValue(address.addressDescription, ''),
                hasNext: setDefaultValue(address.hasNext, false),
                addressDescriptionNat: setDefaultValue(address.addressDescriptionNat, ''),
                outdoorNumberNat: setDefaultValue(address.outdoorNumberNat, ''),
                interiorNumberNat: setDefaultValue(address.interiorNumberNat, ''),
                zipCodeNat: setDefaultValue(address.zipCodeNat, ''),
                colonyKeyNat: setDefaultValue(address.colonyKeyNat, ''),
                municipalityKeyNat: setDefaultValue(address.municipalityKeyNat, ''),
                municipalityDescriptionNat: setDefaultValue(address.municipalityDescriptionNat, ''),
                stateKeyNat: setDefaultValue(address.stateKeyNat, ''),
                stateDescriptionNat: setDefaultValue(address.stateDescriptionNat, ''),
                countryKeyNat: setDefaultValue(address.countryKeyNat, ''),
            };
        } else {
            return {
                expedientId: 0,
                workflowId: 0,
                viewId: 0,
                viewFatherId: 0,
                kycId: 0,
                addressId: null,
                streetDescription: '',
                streetDescriptionNat: '',
                outdoorNumber: '',
                interiorNumber: '',
                zipCode: '',
                colonyKey: '',
                colonyDescription: '',
                colonyDescriptionNat: '',
                municipalityKey: '',
                municipalityDescription: '',
                stateKey: '',
                stateDescription: '',
                countryKey: '',
                addressDescription: '',
                hasNext: false,
                addressDescriptionNat: '',
                outdoorNumberNat: '',
                interiorNumberNat: '',
                zipCodeNat: '',
                colonyKeyNat: '',
                municipalityKeyNat: '',
                municipalityDescriptionNat: '',
                stateKeyNat: '',
                stateDescriptionNat: '',
                countryKeyNat: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: AddressServiceRequestExtended, props) => {
        const errors: FormikErrors<AddressServiceRequestExtended> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormLocationInfo);

function LocationInfoForm(props: InferPropTypes<typeof LocationInfoForm.propTypes>) {
    const {submitHandler, fields, address, showAdditionalAddress} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            address={address}
            showAdditionalAddress={showAdditionalAddress}
        />
    );
}

export default LocationInfoForm;
